import * as React from 'react';

import classNames from 'classnames';

import { Button, EButtonType } from '@ui';

import { IButtonDefaultProps } from './types';

import * as s from './ButtonDefault.scss';

export const ButtonDefault = (props: IButtonDefaultProps) =>
	<Button
		className={classNames(props.className, s.block, { [s.isFullWidth]: props.isFullWidth })}
		isDisable={props.isDisable}
		onClick={props.onClick}
		type={EButtonType.BUTTON}
	>
		{props.children}
	</Button>;
